module.exports = __webpack_public_path__ + "img/single_pictures_1.5c97df3e.jpg";